import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { buildApiUrl } from "../config/apiConfig";
import "../styles/Login.css";
import thermaxLogo from "../assets/Thermax-Logo.wine01.png";

function ForgotPasswordPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const response = await fetch(buildApiUrl("forgot-password/"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) {
        throw new Error(data.error || "Something went wrong. Please try again.");
      }
      setMessage(data.message || "If an account exists for that email, a temporary password has been sent to it.");
      setSubmitted(true);
    } catch (err) {
      setError(err.message || "Failed to connect to server.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <img src={thermaxLogo} alt="Thermax" className="login-logo" />
      <div className="landing-bg-credit" aria-hidden="true">
        © Powered by Digital Team and PMO Team
      </div>
      <div className="login-container">
        <div className="login-body">
          <div className="login-form-col">
            <h1 className="login-title">Forgot Password</h1>
            <p className="login-subtitle">Enter your email and we'll send you a temporary password.</p>
            {error && <div className="login-error">{error}</div>}
            {submitted ? (
              <>
                <div className="login-error" style={{ background: "rgba(34, 197, 94, 0.15)", borderColor: "#22c55e", color: "#dcfce7" }}>
                  {message}
                </div>
                <button type="button" className="login-btn" onClick={() => navigate("/login")}>
                  Back to Login
                </button>
              </>
            ) : (
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label className="form-label" htmlFor="email">Email</label>
                  <input
                    type="email"
                    id="email"
                    className="form-input"
                    placeholder="Enter your email address"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
                <button type="submit" className="login-btn" disabled={loading}>
                  {loading ? "Sending…" : "Send Temporary Password"}
                </button>
              </form>
            )}
            <p className="forgot-password" onClick={() => navigate("/login")}>Back to Login</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ForgotPasswordPage;
